import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let rafId = null;

    const onScroll = () => {
      if (rafId !== null) {
        return;
      }

      rafId = window.requestAnimationFrame(() => {
        const nextScrolled = window.scrollY > 24;
        setScrolled((prev) => (prev === nextScrolled ? prev : nextScrolled));
        rafId = null;
      });
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""} ${pathname === "/" && !scrolled ? "home-top" : ""}`}>
      <div className="nav-wrap">
        <Link to="/" className="brand" onClick={closeMenu}>
          <img src="/assets/TP visuals gold.png" alt="PixelTone Audio Visuals" />
        </Link>

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
          <NavLink to="/" onClick={closeMenu}>Home</NavLink>
          <NavLink to="/services" onClick={closeMenu}>Services</NavLink>
          <NavLink to="/our-work" onClick={closeMenu}>Our Work</NavLink>
          <NavLink to="/careers" onClick={closeMenu}>Careers</NavLink>
          <NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink>
          <NavLink to="/blog" onClick={closeMenu}>Blog</NavLink>
          <Link to="/contact" className="nav-cta" onClick={closeMenu}>Contact</Link>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
